import React, { Component } from 'react';
import { Spinner } from 'react-bootstrap';
import { action, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import Cookies from 'js-cookie';

import { TICKET_STATUS, TICKET_CLOSE_STATUS } from '@qbot-chat/qbot-uikit';

import { chatStore, rSocket } from '../../store/FrontChatStore';
import { navigateReplace } from '../../helper/HistoryHelper';
import { COOKIE_KEY_CHAT_COMPANY_ID } from '../../const/AppConst';

import ChatView from './pages/ChatView';
import QvChatView from './pages/qv/QvChatView';
import DaishinChatView from './pages/daishin/DaishinChatView';
import HyundairsChatView from './pages/hyundairs/HyundairsChatView';

@observer
class ChatRouter extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }

  @action.bound
  async init() {
    let {
      match: {
        params: { channelId },
      },
    } = this.props;

    if (rSocket.isReady) {
      chatStore
        .setChannel({ id: channelId, status: TICKET_STATUS.ACTIVE })
        .then((r) => {
          let status = chatStore?.channel?.status;
          if (TICKET_CLOSE_STATUS.includes(status)) {
            navigateReplace('/close?isRating=false');
          }
        })
        .catch((e) => {
          navigateReplace(`/maintenance`);
        });

      return;
    }
    console.log('우선 loading으로');
    navigateReplace('/loading');
  }

  componentDidMount() {
    this.init().then();
  }

  render() {
    if (!rSocket.isReady) {
      return (
        <div
          className={`d-flex justify-content-center align-items-center h-100 w-100`}
        >
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      );
    }

    const chatCompID = Cookies.get(COOKIE_KEY_CHAT_COMPANY_ID);

    if (chatCompID === '15') return <QvChatView />;

    if (chatCompID === '17') return <DaishinChatView />;

    if (chatCompID === '35') return <HyundairsChatView />;

    return <ChatView />;
  }
}

export default ChatRouter;
